import {
  CookiesFn,
  getCookie,
  deleteCookie,
  useDeleteCookie
} from 'cookies-next';
import ky from 'ky';

export const api = ky.create({
  prefixUrl: process.env.NEXT_PUBLIC_BACKEND_URL,
  retry: {
    limit: 5,
    delay: (attemptCount) => {
      return 0.3 * 2 ** (attemptCount - 1) * 1000;
    }
  },
  headers: {
    'x-source': 'dashboard'
  },
  hooks: {
    beforeRequest: [
      async (request) => {
        let cookieStore: CookiesFn | undefined;

        if (typeof window === 'undefined') {
          const { cookies: serverCookies } = await import('next/headers');
          cookieStore = serverCookies;
        }
        const token = await getCookie('token', { cookies: cookieStore });

        request.headers.set('Authorization', `Bearer ${token}`);
      }
    ],
    afterResponse: [
      async (request, options, response) => {
        if (response.status === 401) {
          let cookieStore: CookiesFn | undefined;
          if (typeof window === 'undefined') {
            const { cookies: serverCookies } = await import('next/headers');
            cookieStore = serverCookies;
          }
          await deleteCookie('token', { cookies: cookieStore });
        }
      }
    ]
  }
});
